export const getApiDocMarkdownKeyByMessageId = (messageId: string, index: number = 0) => {
    return `${messageId}-${String(index).padStart(2, '0')}-api-doc-markdown`;
};

export const getApiDocMarkdownKeyByArtifactId = (artifactId: string, index: number = 0) => {
    return `${artifactId.slice(0, -3)}-${String(index).padStart(2, '0')}-api-doc-markdown`;
};

export const replaceDomain = (source: string) => {
    return source.replace(/#\{domainName\}/g, window.location.host);
};
